import React from "react";
import { Tag } from "antd";

const Tags = ({ data, onTagClick }) => (
  <div style={{ margin: "16px 0" }}>
    {data.map(o => (
      <Tag
        key={o.id}
        color="blue"
        style={{ marginBottom: 8 }}
        onClick={e => {
          onTagClick(o.text);
        }}
      >
        {o.text}
      </Tag>
    ))}
  </div>
);

export default Tags;



// WEBPACK FOOTER //
// ./src/components/dashboard/Tags.js